import {
  arst_addOperationToGroup,
  arst_changeSent,
  arst_insertColumn,
  arst_insertOperationToGroup,
  arst_insertRow,
  arst_loadData,
  arst_patchData,
  arst_removeGroupingFactor,
  arst_removeOperation,
  arst_setScaffoldColWidth,
  arst_setScaffoldRowHeight,
  arst_setSidebarFilter,
  arst_setSidebarView,
  arst_setTlfViewMode,
  arst_toggleGroupLabelVisibility,
  arst_toggleSidebar,
  arst_updateScaffold,
} from "./functions";
import { arst_insertSubgroup } from "./functions/arst_insertSubgroup";
import {
  ARST_ADD_OPERATION_TO_GROUP,
  ARST_CHANGE_SENT,
  ARST_INSERT_COLUMN,
  ARST_INSERT_OPERATION_TO_GROUP,
  ARST_INSERT_ROW,
  ARST_INSERT_SUBGROUP,
  ARST_LOAD_DATA,
  ARST_PATCH_DATA,
  ARST_REMOVE_GROUPINGFACTOR,
  ARST_REMOVE_OPERATION,
  ARST_SET_SCAFFOLD_COL_WIDTH,
  ARST_SET_SCAFFOLD_ROW_HEIGHT,
  ARST_SET_SIDEBAR_FILTER,
  ARST_SET_SIDEBAR_VIEW,
  ARST_SET_TLF_VIEW_MODE,
  ARST_TOGGLE_GROUP_LABEL_VISIBILITY,
  ARST_TOGGLE_SIDEBAR,
  ARST_UPDATE_SCAFFOLD,
  ArsTableAction,
  ArsTableState,
} from "./interface";

/**
 * Reducer function to manage state updates for the ArsTable component.
 *
 * @param state - Current state of the ArsTable
 * @param action - Action to be performed on the state
 * @returns Updated state
 */
export const arsTableReducer = <T>(
  state: ArsTableState<T>,
  action: ArsTableAction<T>,
): ArsTableState<T> => {
  switch (action.operation) {
    case ARST_ADD_OPERATION_TO_GROUP:
      return arst_addOperationToGroup(state, action);
    case ARST_CHANGE_SENT:
      return arst_changeSent(state);
    case ARST_LOAD_DATA:
      return arst_loadData(state, action);
    case ARST_PATCH_DATA:
      return arst_patchData(state, action);
    case ARST_REMOVE_GROUPINGFACTOR:
      return arst_removeGroupingFactor(state, action);
    case ARST_INSERT_COLUMN:
      return arst_insertColumn(state, action);
    case ARST_INSERT_ROW:
      return arst_insertRow(state, action);
    case ARST_INSERT_OPERATION_TO_GROUP:
      return arst_insertOperationToGroup(state, action);
    case ARST_INSERT_SUBGROUP:
      return arst_insertSubgroup(state, action);
    case ARST_REMOVE_OPERATION:
      return arst_removeOperation(state, action);
    case ARST_SET_SCAFFOLD_COL_WIDTH:
      return arst_setScaffoldColWidth(state, action);
    case ARST_SET_SCAFFOLD_ROW_HEIGHT:
      return arst_setScaffoldRowHeight(state, action);
    case ARST_SET_SIDEBAR_VIEW:
      return arst_setSidebarView(state, action);
    case ARST_SET_SIDEBAR_FILTER:
      return arst_setSidebarFilter(state, action);
    case ARST_TOGGLE_SIDEBAR:
      return arst_toggleSidebar(state);
    case ARST_SET_TLF_VIEW_MODE:
      return arst_setTlfViewMode(state, action);
    case ARST_TOGGLE_GROUP_LABEL_VISIBILITY:
      return arst_toggleGroupLabelVisibility(state, action);
    case ARST_UPDATE_SCAFFOLD:
      return arst_updateScaffold(state, action);
  }
  return state;
};
